import { BLACK, BLACK_100, BLACK_500, BLACK_600, BLACK_700, BLACK_800, BLACK_900, BLUE_500, BLUE_GREY_200, BLUE_GREY_400, BLUE_GREY_900, BLACK_400, LILAC_300, LILAC_400, LILAC_800, WHITE } from '../colors';
export var badgeConfig = {
  label: '',
  size: 'md',
  isSelected: false,
  type: 'single',
  showPrefixIcon: false,
  showPostfixIcon: false,
  showNotifier: false,
  notifierNumber: 0,
  disabled: false,
  controlState: 'none',
  config: {
    states: {
      none: {
        controlStates: {
          none: {
            backgroundColor: LILAC_400,
            textColor: BLACK_900,
            prefixIconColor: BLACK_900,
            postfixIconColor: BLACK_900
          },
          disabled: {
            backgroundColor: LILAC_400,
            textColor: LILAC_800,
            prefixIconColor: LILAC_800,
            postfixIconColor: BLACK_800
          },
          hover: {
            backgroundColor: LILAC_300,
            borderColor: LILAC_800,
            textColor: BLACK_900,
            prefixIconColor: BLACK_900,
            postfixIconColor: BLACK_900
          },
          pressed: {
            backgroundColor: LILAC_300,
            textColor: BLACK_900,
            prefixIconColor: BLACK_900,
            postfixIconColor: BLACK_900
          }
        }
      },
      selected: {
        controlStates: {
          none: {
            backgroundColor: BLACK_900,
            textColor: BLACK_100,
            prefixIconColor: BLACK_100,
            postfixIconColor: BLACK_100
          },
          disabled: {
            backgroundColor: BLACK_500,
            textColor: BLACK_700,
            prefixIconColor: BLACK_700,
            postfixIconColor: BLACK_700
          },
          hover: {
            backgroundColor: BLACK_800,
            borderColor: BLACK_900,
            textColor: BLACK_100,
            prefixIconColor: BLACK_100,
            postfixIconColor: BLACK_100
          },
          pressed: {
            backgroundColor: BLACK_800,
            textColor: BLACK_100,
            prefixIconColor: BLACK_100,
            postfixIconColor: BLACK_100
          }
        }
      },
      multiSelected: {
        controlStates: {
          none: {
            backgroundColor: BLACK_900,
            textColor: BLACK_100,
            prefixIconColor: BLACK_100,
            postfixIconColor: BLACK_100,
            iconBgColor: BLUE_500,
            iconColor: WHITE
          },
          disabled: {
            backgroundColor: BLACK_500,
            textColor: BLACK_700,
            prefixIconColor: BLACK_700,
            postfixIconColor: BLACK_700,
            iconBgColor: BLACK_600,
            iconColor: WHITE
          },
          hover: {
            backgroundColor: BLACK_800,
            borderColor: BLACK_900,
            textColor: BLACK_100,
            prefixIconColor: BLACK_100,
            postfixIconColor: BLACK_100,
            iconBgColor: BLUE_500,
            iconColor: WHITE
          },
          pressed: {
            backgroundColor: BLACK_800,
            textColor: BLACK_100,
            prefixIconColor: BLACK_100,
            postfixIconColor: BLACK_100,
            iconBgColor: BLUE_500,
            iconColor: WHITE
          }
        }
      }
    },
    size: {
      sm: {
        badgeSize: 24,
        paddingHorizontal: 'SPACING_8',
        iconSize: 10,
        prefixIconSize: 12,
        postfixIconSize: 12
      },
      md: {
        badgeSize: 32,
        paddingHorizontal: 'SPACING_12',
        iconSize: 16,
        prefixIconSize: 20,
        postfixIconSize: 20
      },
      lg: {
        badgeSize: 40,
        paddingHorizontal: 'SPACING_12',
        iconSize: 16,
        prefixIconSize: 20,
        postfixIconSize: 20
      }
    }
  }
};
export var badgeWhiteConfig = Object.assign(Object.assign({}, badgeConfig), {
  config: Object.assign(Object.assign({}, badgeConfig.config), {
    states: {
      none: {
        controlStates: {
          none: {
            backgroundColor: BLUE_GREY_200,
            textColor: BLACK_900,
            prefixIconColor: BLACK_900,
            postfixIconColor: BLACK_900
          },
          disabled: {
            backgroundColor: BLUE_GREY_200,
            textColor: BLUE_GREY_400,
            prefixIconColor: BLUE_GREY_400,
            postfixIconColor: BLUE_GREY_400
          },
          hover: {
            backgroundColor: BLUE_GREY_200,
            borderColor: BLUE_GREY_900,
            textColor: BLACK_900,
            prefixIconColor: BLACK_900,
            postfixIconColor: BLACK_900
          },
          pressed: {
            backgroundColor: BLUE_GREY_400,
            textColor: BLACK_900,
            prefixIconColor: BLACK_900,
            postfixIconColor: BLACK_900
          }
        }
      },
      selected: {
        controlStates: {
          none: {
            backgroundColor: BLACK_900,
            textColor: WHITE,
            prefixIconColor: WHITE,
            postfixIconColor: WHITE
          },
          disabled: {
            backgroundColor: BLACK_500,
            borderColor: BLACK_500,
            textColor: BLACK_600,
            prefixIconColor: BLACK_600,
            postfixIconColor: BLACK_600
          },
          hover: {
            backgroundColor: BLACK_800,
            borderColor: WHITE,
            textColor: WHITE,
            prefixIconColor: WHITE,
            postfixIconColor: WHITE
          },
          pressed: {
            backgroundColor: BLACK,
            textColor: WHITE,
            prefixIconColor: WHITE,
            postfixIconColor: WHITE
          }
        }
      },
      multiSelected: {
        controlStates: {
          none: {
            backgroundColor: BLACK_900,
            textColor: WHITE,
            prefixIconColor: WHITE,
            postfixIconColor: WHITE,
            iconBgColor: BLUE_500,
            iconColor: WHITE
          },
          disabled: {
            backgroundColor: BLACK_500,
            textColor: BLACK_600,
            prefixIconColor: BLACK_600,
            postfixIconColor: BLACK_600,
            iconBgColor: BLACK_600,
            iconColor: BLACK_400
          },
          hover: {
            backgroundColor: BLACK_800,
            borderColor: BLACK_800,
            textColor: WHITE,
            prefixIconColor: WHITE,
            postfixIconColor: WHITE,
            iconBgColor: BLUE_500,
            iconColor: WHITE
          },
          pressed: {
            backgroundColor: BLACK,
            textColor: WHITE,
            prefixIconColor: WHITE,
            postfixIconColor: WHITE,
            iconBgColor: BLUE_500,
            iconColor: WHITE
          }
        }
      }
    }
  })
});
export default {
  light: badgeConfig,
  dark: badgeConfig,
  white: badgeWhiteConfig
};